import { CIcon } from '~/icons/types'

export const ciAuditRequest: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm13.688 6.75.388.01a8.006 8.006 0 0 1 2.016.372c-.042-.061-.073-.127-.119-.186.213-.212.335-.5.337-.8a1.222 1.222 0 0 0-1.279-1.19h-.364L13.8 2.892a2.538 2.538 0 0 0-2.379-1.632l-4.75.006a2.6 2.6 0 0 0-2.545 1.6l-.882 2.09H2.88a1.223 1.223 0 0 0-1.28 1.19 1.145 1.145 0 0 0 .365.84 3.48 3.48 0 0 0-.715 2.158v2.2c0 .016.007.03.008.046l2.823.943h2.025a7.951 7.951 0 0 1 7.582-5.583ZM5 9.98H3.25v-1.5H5a.75.75 0 0 1 0 1.5Zm-.5-4.14.988-2.35a1.174 1.174 0 0 1 1.09-.73h4.843a1.07 1.07 0 0 1 .981.685l1.009 2.4L4.5 5.84Zm-.658 7.47L1.6 12.56v1.133a1.533 1.533 0 0 0 1.5 1.57h1.15a1.534 1.534 0 0 0 1.493-1.57v-.357H4a.524.524 0 0 1-.158-.027Z',
      fill: 'currentColor'
    },
    {
      d:
        'M21.969 19.412 20.7 18.399l-1.2-.961a6.427 6.427 0 0 0-5.483-9.18l-.351-.01a6.438 6.438 0 0 0 .02 12.875l.339-.009a6.406 6.406 0 0 0 3.365-1.165l1.072 1.071 1.006 1.005a2.032 2.032 0 0 0 1.421.673 1.758 1.758 0 0 0 1.247-.564 1.778 1.778 0 0 0-.167-2.722Zm-8.281.212a4.937 4.937 0 1 1 0-9.875l.235.006a4.937 4.937 0 0 1-.235 9.869Z',
      fill: 'currentColor'
    },
    {
      d:
        'm14.976 12.963-.052.055L13 15.325l-.924-1.117a.75.75 0 1 0-1.156.957l1.5 1.813a.752.752 0 0 0 1.154 0l2.5-3 .046-.06a.75.75 0 0 0-1.146-.956l.002.001Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'audit-request',
  type: 'solid',
  fill: 'none'
}
